import { dispatch } from "@rematch/core";
import { forgetService } from "../../services/feathers.service";

const initialState = {
  forgotPwdSuccess: false,
  forgotPwdError: false,
};

export default {
  state: initialState,
  reducers: {
    setForgotPwdSuccess(state, payload) {
      return {
        ...state,
        forgotPwdSuccess: payload,
      };
    },
    setForgotPwdError(state, payload) {
      return {
        ...state,
        forgotPwdError: payload,
      };
    },
    clear() {
      return initialState;
    },
  },
  effects: {
    async forgotAsync(payload) {
      // const {email} = payload;
      try {
        await forgetService.create({ email: payload.email }); // change made for KLM-8846
        dispatch.forgot.setForgotPwdSuccess(true);
      } catch (err) {
        dispatch.forgot.setForgotPwdError(true);
        throw err;
      }
    },
    clearForgetData() {
      dispatch.forgot.setForgotPwdSuccess(false);
      dispatch.forgot.setForgotPwdError(false);
    },
  },
};
